import React from "react";
import { Link } from "react-router-dom";
import "../styles/Research1.css";
import "../styles/Navbar.css";

import headerborder from "../assets/images/bordder-line.svg";
import researchimage from "../assets/images/research-1.svg";
import researchimage2 from "../assets/images/research-2.svg";
import researchimage4 from "../assets/images/research-4.svg";
import fullreport from "../assets/images/full-report-icon.svg";
import reasearchcardborder from "../assets/images/research-card-border.svg";
import content3 from "../assets/images/content3.svg";
import analytics3 from "../assets/images/analytics-3.png";
import analytics2 from "../assets/images/analytics-3-2.png";
import tangoLogo from "../assets/logos/Tango.png";

const Research3 = () => {
    // Asset paths from src/assets folder


    return (
        <div className="research-page">
            {/* Research Content */}
            <div className="Research1-container">
                <div className="research-heading-container">
                    <img src={headerborder} alt="headerborder" className="headerborder" />
                    <div className="research-content-wrapper">
                        <div className="inner-research">
                            <div className="research-header-content">
                                <div>
                                    <p className="research-heading">
                                        Impact study of World Vision Rwanda programs
                                    </p>
                                    <p className="research-heading">
                                        focusing on community development and educational initiatives
                                    </p>
                                </div>
                                <img src={tangoLogo} alt="Tango Logo" className="tango-logo" />
                            </div>
                            <p className="date">January - June 2024</p>
                            <p className="partnership">
                                Partnership: IHEMA Research Team & World Vision Rwanda
                            </p>
                            <p className="research-role-detail">
                                <span className="role-label">IHEMA's Role:</span>
                                <span className="role-badge">Data Collection &amp; Reporting</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="content-container">
                    <p className="content-paragraph">
                        Continuing its partnership with TANGO International, IHEMA Research Team supported a comprehensive impact evaluation for World Vision Rwanda, one of the country’s largest international NGOs with multi-sector programming in child protection, livelihoods, health and nutrition, and community resilience. The evaluation required rigorous methodological approaches to assess program impact, including careful attention to attribution, data quality, and interpretation of complex development outcomes.
                    </p>
                    <p className="content-paragraph">
                        IHEMA Research Team led intensive quantitative and qualitative capacity-building and data collection support. The team designed and delivered advanced enumerator training focused on impact evaluation principles, standardized data collection protocols, bias mitigation, and respondent engagement for complex survey instruments. Training combined theoretical grounding with practical field simulations to ensure high-quality, consistent data collection across diverse program contexts.
                    </p>
                    <p className="content-paragraph">
                        For the qualitative component, IHEMA designed and implemented in-depth data collection tools to capture beneficiary experiences and program impact pathways across multiple thematic areas. Methods included in-depth interviews, focus group discussions, and participatory approaches tailored to different community groups. Tools were continuously reviewed and refined throughout implementation to probe emerging themes and unexpected effects, in close coordination with TANGO International and World Vision staff.
                    </p>
                    <p className="content-paragraph">
                        IHEMA also led qualitative data synthesis and analysis through the development of structured data matrices that enabled systematic cross-case comparison and thematic analysis. This analytical work supported the identification of key patterns, causal mechanisms, implementation challenges, and program strengths. Findings contributed to real-time learning as well as the final evaluation report, providing World Vision Rwanda with actionable, contextually grounded insights to inform program improvement and strategic decision-making.
                    </p>

                    <div className="content-paragraph-2">
                        <p className="content-paragraph"><span className="methodological-innovation">Methodological Innovation:</span>This project demonstrated IHEMA Research Team's ability to seamlessly integrate quantitative and qualitative approaches within a rigorous impact evaluation framework. Our mixed-methods expertise allowed for triangulation of findings across data sources, strengthening the validity of conclusions and providing a holistic understanding of World Vision Rwanda's development impact across program domains.</p>
                    </div>
                    <img src={content3} alt="content" className="content-image" />
                    <div className="analytics">
                        <img src={analytics3} alt="Analytics" className="analytics" />
                        <img src={analytics2} alt="Analytics" className="analytics" />
                    </div>
                </div>
                <div className="research-card-container">
                    <img src={reasearchcardborder} alt="headerborder" className="research-card-border" />
                    <div className="outer-container">
                        <p className="more-assessments">More Assessments</p>
                        <div className="cards-container">
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                                        Phase II Endline & Phase III Baseline
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mcgovern-dole" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        Rapid review of the Mastercard Foundation COVID-19 Recovery
                                        and Resilience Program (CRRP Rwanda)
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage2}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mastercard-foundation" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                                        Phase II Midterm Evaluation
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage4}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mcgovern-dole-midterm" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Research3;
